import { useNavigate } from 'react-router-dom';
import BootstrapNavbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Cookies from 'js-cookie';
import ajax from '~/util';
import useToken from '~/useToken';
import useCurrentUser from '~/useCurrentUser';

const Navbar = () => {

    const navigate = useNavigate();
    const { removeToken } = useToken();
    const { removeCurrentUser, currentUser } = useCurrentUser();

    const handleLogout = async() => {
        await ajax.request('post','/logout')
            .then(res => {
                removeToken();
                removeCurrentUser();
                Cookies.remove('refreshToken');
                navigate('/login');
            }).catch(err => {
                console.log(err);
            });
    }

    return (
        <BootstrapNavbar sticky='top' bg='light' data-bs-theme='light'>
            <Container>
                <Nav className='me-auto'>
                    <Nav.Link href='/'>Home</Nav.Link>
                </Nav>
                {currentUser.admin && (<Nav className='justify-content-end'>
                    <Nav.Link href={'/metrics'}>Metrics</Nav.Link>
                </Nav>)}
                <Nav className='justify-content-end'>
                    <Nav.Link href={`/users/${currentUser._id}`}>Profile</Nav.Link>
                </Nav>
                <Nav className='justify-content-end'>
                    <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                </Nav>
            </Container>
        </BootstrapNavbar>
    )
}

export default Navbar;
